<template>
  <div class="print-wrapper">
    <div
      ref="printSection"
      class="gate-pass"
      v-for="(gatepass, index) in gatepasses_data"
      :key="index"
    >
      <div class="gatepass-box">
        <!-- Logo -->
        <div class="logo">
          <img
            class="img-fluid for_logo"
            src="../../assets/images/logo/hdlogo.png"
            alt="logo"
          />
        </div>
    
        <!-- Visitor Details -->
        <div class="details mt-4">
          <table>
            <tr>
              <td><span>Name</span></td>
              <td>: {{ gatepass?.name }}</td>
              <td rowspan="5" class="photo">
                <img
                  :src="`${$hostname}/writable/uploads/visitors/${gatepass.photo}`"
                  alt="Visitor"
                  v-if="gatepass?.photo"
                />
              </td>
            </tr>
              <tr>
                  <td><span>Firm Name</span></td>
                  <td>: {{ gatepass?.firmname }}</td>
              </tr>
            <tr>
              <td><span>Person To Meet</span></td>
              <td>: {{ gatepass?.whom_name }}</td>
            </tr>
            <tr v-if="gatepass?.accessories">
              <td><span>Accessories</span></td>
              <td>: {{ gatepass?.accessories }}</td>
            </tr>
            <tr>
              <td><span>Purpose</span></td>
              <td>: {{ gatepass?.purpose }}</td>
            </tr>
            <tr>
              <td><span>Date</span></td>
              <td>: {{ gatepass?.schedule_date }}</td>
            </tr>
            <tr>
              <td><span>Valid On</span></td>
              <td>: {{ gatepass?.schedule_date }}</td>
            </tr>
          </table>
        </div>

        <!-- Signatures -->
        <div class="signatures  mt-5">
          <div>Sign of Visitor</div>
          <div>Sign. of Duty Officer</div>
          <div>Sign of Officer Visited</div>
        </div>

        <!-- QR Code -->
        <div class="text-center">
          <canvas :ref="'qrcodeCanvas' + index"></canvas>
        </div>
      </div>
    </div>

    <button class="btn btn-danger btn-pill mt-3" @click="printGatePass">Print Gate Pass</button>
  </div>
</template>

<script>
import QRCode from 'qrcode';

export default {
  name: 'HDGatepassPrint',
  props: {
    gatepasses_data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    printGatePass() {
      window.print();
    },
   async generateQRCode(index, token) {
          if (token) {
            let canvas = this.$refs[`qrcodeCanvas${index}`];
            if (Array.isArray(canvas)) {
              canvas = canvas[0];
            }
            if (canvas && canvas.getContext) {
              try {
                await QRCode.toCanvas(canvas, `${this.$api_host}vp?q=${token}`, {
                  width: 100,
                  margin: 1,
                });
              } catch (err) {
                console.error('QR code generation error:', err);
              }
            } else {
              console.error("QR code generation error: canvas is invalid", canvas);
            }
          }
        }
  },
  watch: {
    gatepasses_data: {
      handler(newData) {
        if (Array.isArray(newData)) {
          this.$nextTick(() => {
            newData.forEach((pass, index) => {
              this.generateQRCode(index, pass.token);
            });
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.gatepass-box {
  font-family: 'Arial', sans-serif;
  width: 4in;
  height: 4in;
  border: 2px solid black;
  padding: 10px;
  box-sizing: border-box;
  font-size: 10px !important;
  background-color: #fff;
}
td span,td{
  font-size: 11px !important;  
}
.logo img {
  width: 100%;
  max-height: 30px;
  object-fit: contain;
  margin-bottom: 5px;
}

.details table {
  width: 100%;
  border-collapse: collapse;
}

.details td {
  vertical-align: top;
  padding: 2px;
}

.photo img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border: 1px solid #000;
}

.signatures {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  font-size: 11px;
}
</style>

<style>
@media print {
  @page {
    size: A4;
    margin: 0;
  }
.btn {
 display: none;   
}
  body {
    margin: 0;
    padding: 0;
  }

  .print-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .gate-pass {
    position: absolute;
    width: 4in;
    height: 4in;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    page-break-after: always;
  }

  button {
    display: none;
  }
}
</style>
